import { FlowV2_Update_Action, FlowV2_Update_Metadata } from '~/graphql/types';
import type { ClientFlowAction } from '~/graphql/types.client';

/**
 * Return metadata for all wait and trickle actions that will be deleted
 * keywords: setMetadata
 */
const assignFlowMetadata = ({
  prevMetadata,
  initialActions,
  deletedMetadataActions,
  deletedActionIds,
}: {
  prevMetadata: Array<FlowV2_Update_Metadata>;
  deletedMetadataActions: Array<string>;
  initialActions: Array<ClientFlowAction>;
  deletedActionIds: Array<string>;
}): Array<FlowV2_Update_Metadata> => {
  const filteredPrevious: Array<FlowV2_Update_Metadata> = prevMetadata.filter(
    act => !deletedMetadataActions.includes(act.flowBlueprintActionId),
  );
  const metadataArray: Array<FlowV2_Update_Metadata> =
    deletedMetadataActions.map(id => ({
      flowBlueprintActionId: id,
      action: FlowV2_Update_Action.Drop,
    }));

  // check parents of previously assigned actions, change metadata value if it has any deleted parents
  const prev = filteredPrevious.map(metadata => {
    const subjectAction = initialActions.find(
      a => a.id === metadata.flowBlueprintActionId,
    );

    if (
      subjectAction &&
      'parentIds' in subjectAction &&
      subjectAction.parentIds.some(r => deletedActionIds.includes(r))
    ) {
      return {
        flowBlueprintActionId: metadata.flowBlueprintActionId,
        action: FlowV2_Update_Action.Drop,
      };
    }

    return metadata;
  });

  return [...prev, ...metadataArray];
};
export default assignFlowMetadata;
